var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNftCardMarketBackground = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 80,
    viewBox: "0 0 74 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 24.1262V55.8738C0.750042 57.3223 1.13675 58.7455 1.87127 59.9999C2.60579 61.2545 3.66226 62.2962 4.93447 63.0205L32.8155 78.8944C34.0878 79.6187 35.531 80 37 80C38.4691 80 39.9121 79.6187 41.1844 78.8944L69.0655 63.0205C70.3378 62.2962 71.3942 61.2545 72.1288 59.9999C72.8634 58.7455 73.25 57.3223 73.25 55.8738V24.1262C73.25 22.6776 72.8634 21.2545 72.1288 20.0001C71.3942 18.7455 70.3378 17.7038 69.0655 16.9795L41.1844 1.10563C39.9121 0.381321 38.4691 0 37 0C35.531 0 34.0878 0.381321 32.8155 1.10563L4.93447 16.9795C3.66226 17.7038 2.60579 18.7455 1.87127 20.0001C1.13675 21.2545 0.750042 22.6776 0.75 24.1262Z",
    fill: "#1F408C"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNftCardMarketBackground);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/nft-card-market-background.e9cfbcddb02fd1741ea27a9840ffa395.svg";